import { $, _, Backbone, Radio, Datepicker, Foundation, moment } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { Recurrencies, Biscuit, Notification } from "../../utils";
import Inboomai18n from "../../utils/Inboomai18n";
import { parseUrlIntoObject } from "../../utils/Uri";

import Appointment from "../../models/Appointment";
import Pricetariff from "../../models/Pricetariff";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

// fullcalendar locales loaded dynamic via globals.js

// @todo Event details shown as an on-hover-tooltip
// should become isolated in a separate View

const a = "${a}";

export default InboomaBaseView.extend({
  el: "#inb-c-main-appointments",
  template: `
      <div id="calendar-header-left"></div>
      <div id="calendar-header-right">
          <div class="app-appointment-wrapper small-only-float-container">
              <a
                  id="add-appointment"
                  class="button small beautify"
                  href="appointments/<%- active_calendar %>/event/add"
                  data-inb-action-link="write">
                  <i class="fi fi-page-add"></i>
                  <span>
                      <%= t('add_${a}',{a:t('appointment')}) %>
                  </span>
              </a>
          </div>
      </div>
      <div id="calendar">
          <!-- fullCalendar -->
      </div>`,

  templateContext() {
    return {
      active_calendar: this.getOption("active_calendar"),
    };
  },

  ui: {
    calendar: "#calendar",
    calendarHeaderLeft: "#calendar-header-left",
    calendarHeaderRight: "#calendar-header-right",
  },

  collectionEvents: {
    add: "_addOne",
    remove: "_removeOne",
    reset: "render",
  },

  initialize() {
    this.render();
  },

  /**
   * Called with parameters like ´start´ and ´end´ as part of the uri.
   * Creates or patches an appointment with the description 'action:blockday' to indicate a blocking.
   * OR patches an appointment with the (meainingless) description 'action:redo_blockday' to remove block indicator.
   *
   * @todo Modularize - put into model or own method
   * @todo Don't make it necessary to call window.location.reload
   *
   * @param {Number} id event_id
   */
  toggleBlockState(id) {
    const that = this,
      request = parseUrlIntoObject(),
      event = this.collection.get(id),
      _contingent = this.options.contingents.models[0], // @todo Is this right at all?
      contingent = this.options.all_contingents.get(_contingent.get("id"));

    let appointment;

    if (typeof request.appointment_id !== "undefined") {
      if (typeof that.options.appointments.get(request.appointment_id) !== "undefined") {
        appointment = that.options.appointments.get(request.appointment_id);
        appointment = OffCanvasBehavior.prototype.normalizeModel(appointment);

        if (appointment.get("description") === "action:blockday") {
          if (confirm(this.t("event_confirm_unset_blocking"))) {
            // UNMARK appointment to make event public again
            appointment.save(
              {
                description: "action:redo_blockday",
              },
              {
                patch: true,
                success: (model, response) => {
                  new Notification({
                    message: that.t("event_removed_blocking"),
                    duration: 5000,
                    type: "success",
                    closeable: true,
                    icon: "fi fi-check",
                  });

                  Backbone.history.navigate("appointments/" + that.options.active_calendar, {
                    trigger: true,
                  });
                  window.location.reload();
                },
                error: () => {
                  new Notification({
                    message: that.t("request_error"),
                    duration: 5000,
                    type: "warning",
                    closeable: true,
                    icon: "fi fi-x",
                  });

                  Backbone.history.navigate("appointments/" + that.options.active_calendar, {
                    triger: true,
                  });
                },
              }
            );
          } else {
            Backbone.history.navigate("appointments/" + that.options.active_calendar, {
              trigger: true,
            });
            return;
          }

          return;
        }
      }
    }

    if (confirm(this.t("confirm_set_blocking"))) {
      if (typeof appointment === "undefined") {
        // Create new appointment model first using data provided in Uri

        const numberActive = contingent.getNumbersByDay(moment(request.start)).number;

        appointment = new Appointment({
          // Usually we would set back the time to 00:00:00
          // but temporarily deactivated it

          client_id: Biscuit.get("user.client_id"),
          name: event.get("title") + " (block day)",
          max_pers_count: numberActive,
          current_available_pers_count: numberActive,
          contingent_id: contingent.get("id"),
          event_id: event.get("id"),
          begin: moment(request.start).format("YYYY-MM-DD HH:mm"), //.hours(0).minutes(0).seconds(0).format('YYYY-MM-DD HH:mm'),
          end: moment(request.end).isValid
            ? moment(request.end).format("YYYY-MM-DD HH:mm") //hours(0).minutes(0).seconds(0).format('YYYY-MM-DD HH:mm')
            : null,
        });
      }

      appointment = OffCanvasBehavior.prototype.normalizeModel(appointment);

      // Finally: POST block command to /appointments
      appointment.save(
        {
          description: "action:blockday",
        },
        {
          type: appointment.id == "" || appointment.id == null ? "POST" : "PUT",
          success(model, response) {
            new Notification({
              message: that.t("event_set_blocking"),
              duration: 5000,
              type: "success",
              closeable: true,
              icon: "fi fi-power",
            });

            that.options.appointments.add(appointment);

            Backbone.history.navigate("appointments/" + that.options.active_calendar, {
              trigger: false,
            });

            window.location.reload();
          },
          error(model, response) {
            new Notification({
              message: that.t("request_error"),
              duration: 5000,
              type: "warning",
              closeable: true,
              icon: "fi fi-x",
            });

            Backbone.history.navigate("appointments/" + that.options.active_calendar, {
              trigger: true,
            });
          },
        }
      );
    } else {
      Backbone.history.navigate("appointments/" + that.options.active_calendar, { trigger: true });
    }
  },

  /**
   * Displays an event in fullCalendar.
   * If an event has no appointments yet, generate those and call method again.
   */
  _addOne(event, fromDate, endDate, max) {
    // @todo re-investigate params: all of'em required?
    const that = this;

    if (typeof event.toJSON === "function") {
      event = event.toJSON();
    }

    if (
      !_.isUndefined(event.separation_count) &&
      !_.isNull(event.separation_count) &&
      event.separation_count !== "" &&
      typeof event.parent_id === "undefined"
    ) {
      // Well that one has recurrings!
      // set parent_id to enable recurrings-styling
      // in eventAfterRender

      event.parent_id = true;

      if (event.valid_to !== null && event.valid_to !== "") {
        endDate = event.valid_to;
      }

      let intelliMax; // Only generate events in visible timespan
      // Note that calculation starts with 23rd of previous month
      // in order to show events that take place in first week

      switch (event.rrule) {
        default:
        case "weekly":
          intelliMax = 6;
          break;
        case "monthly":
        case "yearly":
          intelliMax = 2;
          break;
      }

      new Recurrencies({
        event,
        fromDate,
        endDate,
        max: intelliMax,
        then: (_event) => that._addOne(_event),
      });
    } else {
      this.fc.fullCalendar("renderEvent", event, false);
    }
  },

  _removeOne(event) {
    console.log("remove event", event);
    this.fc.fullCalendar("removeEvents", event.get("id"));
  },

  onRender() {
    const domSpam = document.getElementsByClassName("appointment-dropdown");

    if (domSpam.length >= 1) {
      _.each(domSpam, (spam) => {
        if (typeof spam !== "undefined") {
          spam.remove();
        }
      });
    }

    const that = this,
      maxDate = moment().add(2, "years").toDate();

    let lastViewStart = null;

    if (typeof this.fc !== "undefined") {
      console.log("instance given, will re-render", this.fc);
      this.fc.fullCalendar("rerenderEvents");
      return; // ???
    }

    this.fc = this.getUI("calendar");

    this._calendarEvents = []; // ???

    this.fc.fullCalendar({
      locale: Inboomai18n.getActiveLanguageShortcode(),
      header: {
        left: "prev,next today",
        center: "title",
        right: "",
      },
      displayEventEnd: true,
      selectable: true,
      navLinks: true,
      editable: false,
      timeFormat: "HH:mm",
      eventStartEditable: false,
      eventLimit: true, // show "show more" link when too many events in list
      events: that._calendarEvents,

      viewRender: (view, container) => {
        if (true) {
          //lastViewStart === null || lastViewStart != view.intervalStart.format('MMYY')) {

          lastViewStart = view.intervalStart.format("MMYY");

          if (view.start > maxDate) {
            that.fc.fullCalendar("gotoDate", maxDate);
          } else {
            $(".fc-button").addClass("button").addClass("secondary").addClass("hollow");

            // @todo show events that would take place on first of month...
            const start = that.fc.fullCalendar("getDate").subtract(1, "months").date(23);

            const end = start.clone().add(2, "months").date(1);

            _.each(that.collection.models, (event, key) => {
              event = event.toJSON();

              if (typeof event.valid_to !== "undefined" && !_.isNull(event.valid_to)) {
                // Is event still valid?
                if (moment(event.valid_to).isSameOrAfter(moment())) {
                  that._addOne(event, start.toDate(), end.toDate());
                }
              } else {
                that._addOne(event, start.toDate(), end.toDate());
              }
            });
          }
        }

        $("a.fc-day-number").removeAttr("data-goto");
      },

      eventAfterAllRender() {
        // const allEventContainers = document.getElementsByClassName('fc-event');
        //  if (allEventContainers.length) {

        if ($(".fc-event").length) {
          $(".fc-event").each(function () {
            if ($("." + $(this).attr("data-class")).length === 1) {
              // If there's only one event on a day:
              $(this).addClass("full-height");
            }
          });
        }
      },

      eventRender: (event, element, view) => {
        // Hide all days out of scope
        if (moment(event.start).format("M") !== moment(view.intervalStart).format("M")) {
          return false;
        }
      },

      /*
          @todo Instead of using below's eventAfterRender hook, create the popup only as required (when hovered)
          eventMouseover : ( event, jsEvent, view ) => {
              console.log('event mouseover', event, this.collection.get(event.id));
          },
        
          eventMouseout : ( event, jsEvent, view ) => {

          },*/

      /**
       * @param { object } fcEvent
       * @param { jQuery elem } element
       * @param view
       */
      eventAfterRender: (event, element, view) => {
        let is_recurring = false,
          is_blocked = false,
          is_outbooked = false,
          appointment_id = null,
          params_for_recurring = "",
          start = moment(event.start),
          end = moment(event.end),
          event_date_title = "",
          renderedSelectOptions = "",
          renderedReservations = "",
          availabilities_per_contingent = {},
          availabilities_per_contingent_rendered = "";

        const tempId = event.id + start.format("dmy") + new Date().getMilliseconds();

        if (typeof event.parent_id !== "undefined") {
          is_recurring = true;

          const _event = that.collection.get(event.id);

          if (typeof _event !== "undefined") {
            _event.set("is_recurring", true);

            _.each(_event.get("appointments"), (appointment) => {
              if (moment(appointment.begin).format("DDMMYY") === start.format("DDMMYY")) {
                if (appointment.description === "action:blockday") {
                  // Add opacity to indicate block'ness...
                  element.addClass("event-is-blocked");
                  is_blocked = true;

                  if (event_date_title.indexOf(that.t("appointment_blocked_not_bookable")) === -1) {
                    event_date_title += that.t("appointment_blocked_not_bookable") + " ";
                  }
                }

                // Reset local start & end and give hint on change in tooltip
                // This requires an event-appointment 1:1 relation!!!
                appointment_id = appointment.id;
                start = moment(appointment.begin);
                end = moment(appointment.end);

                if (appointment.begin == appointment.end) {
                  end = moment("isNotValid"); // != isValid
                }

                availabilities_per_contingent[appointment.contingent_id] = {
                  total: appointment.max_pers_count,
                  avail: appointment.current_available_pers_count,
                };

                // Really highlight event as booked???
                let hasMinOneValidReservation = false;

                _.each(appointment.reservations, (reservation) => {
                  if (!hasMinOneValidReservation) {
                    if (reservation.status !== "cancelled") {
                      hasMinOneValidReservation = true;
                    }
                  }
                });

                if (
                  hasMinOneValidReservation &&
                  appointment.max_pers_count != appointment.current_available_pers_count
                ) {
                  element
                    .addClass("has-bookings")
                    .addClass("event-is-rescheduled")
                    .hover(
                      function () {
                        $(this).addClass("beautify");
                      },
                      function () {
                        $(this).removeClass("beautify");
                      }
                    );
                }

                if (appointment.current_available_pers_count === 0) {
                  is_outbooked = true;
                  element.addClass("is-outbooked");
                }

                if (typeof appointment.reservations !== "undefined") {
                  if (appointment.reservations.length) {
                    // Display linked reservations as list
                    // @todo In order to show user data, we need an async approach!

                    /*const pricetariffs = Radio.channel('pricetariffs').request('get:data'),
                                users = Radio.channel('users').request('get:data');*/

                    renderedReservations = '<ul class="inb-appointment-reservations">';

                    _.each(appointment.reservations, (reservation, key) => {
                      let realAmount = "",
                        pricetariff = "",
                        order_nbr = "",
                        user;

                      if (typeof reservation.contingents !== "undefined") {
                        if (typeof reservation.contingents[0] !== "undefined") {
                          realAmount = reservation.contingents[0]._joinData.amount;
                          pricetariff =
                            reservation.contingents[0].pricetariffs[0].name ||
                            "Unknown pricetariff";
                          order_nbr = reservation.order.order_nbr;
                          //user = users.get(reservation.order.user_id);
                        }
                      }

                      if (/*typeof user === 'undefined' ||*/ reservation.status === "cancelled") {
                        return;
                      }

                      /*let userDescription = '';

                              if (user.get('title') === null || user.get('title') === '' || user.get('title') === 'mx') {
                                  userDescription = user.get('first_name') + ' ' + user.get('last_name') + ', ';
                              } else {
                                  userDescription = that.t('user_title_' + user.get('title')) + ' ' + user.get('last_name') + ', ';
                              }*/

                      renderedReservations += `
                                <li>
                                    <a
                                        title="${that.t("open_link")}"
                                        href="appointments/ordersForm/${reservation.order_id}/${
                        reservation.id
                      }">
                                        <span
                                            title="${that.t("order_nbr")} ${order_nbr}">
                                            #${order_nbr}
                                        </span>: 
                                        ${realAmount} ${that.t("person_s")}, 
                                        ${Number(reservation.price).toLocaleString("de-DE", {
                                          minimumFractionDigits: 2,
                                        })}${Biscuit.getClientCurrency()}
                                        (${pricetariff} - ${that.t(
                        "status",
                        null,
                        "capital"
                      )}: ${that.t(reservation.status, null, "capital")})
                                    </a>
                                </li>`;
                    });

                    renderedReservations += "</ul>";
                  }
                }

                element
                  .find(".fc-time")
                  .html(start.format("HH:mm") + (end.isValid() ? " - " + end.format("HH:mm") : ""));
              }
            });
          }
        }

        _.each(that.options.contingents.models, (_contingent) => {
          // Show availabilities per contingent

          const contingent = that.options.all_contingents.get(_contingent.get("id"));

          // @todo Sometimes, availabilities_per_contingent[...].total/avail is null.
          //       That seems to be wrongly set in blockDay method up
          const total =
              typeof availabilities_per_contingent[contingent.get("id")] !== "undefined" &&
              availabilities_per_contingent[contingent.get("id")].total !== null
                ? availabilities_per_contingent[contingent.get("id")].total
                : contingent.getNumbersByToday(start).number,
            avail =
              typeof availabilities_per_contingent[contingent.get("id")] !== "undefined" &&
              availabilities_per_contingent[contingent.get("id")].avail !== null
                ? availabilities_per_contingent[contingent.get("id")].avail
                : total;

          availabilities_per_contingent_rendered += `<li title="${that.t("${a}_of_${b}_booked", {
            a: total - avail,
            b: total,
          })}">
                    ${contingent.get("name")}
                    <span class="float-right inb-appointment-availables">
                      <i class="fi fi-torso"></i> ${total - avail}/${total}
                    </span>
                </li>`;
        });

        for (let i = 1; i <= 8; i++) {
          // i <= available_amount
          // @todo make contingent dependent
          renderedSelectOptions += `
                  <option
                      value="${i}"
                      ${i === 1 ? ' selected="selected"' : ""}>
                      ${i} ${that.t("person_s")}
                  </option>`;
        }

        event_date_title +=
          start.format("dd, DD.MM.YY HH:mm") +
          (end.isValid() && end.isAfter(start) ? " - " + end.format("HH:mm") : ""); // WAS: end.format('dd, DD.MM.YY')

        element.addClass("start-" + start.format("DDMMYY"));

        element
          .attr("title", event_date_title)
          .attr("data-inb-appt-id", event.id)
          .attr("data-class", "start-" + start.format("DDMMYY"))
          .attr("data-toggle", tempId);

        params_for_recurring =
          "/&start=" +
          start.format().replace("+02:00", "") +
          "&end=" +
          (end.isValid()
            ? end.format().replace("+02:00", "")
            : start.format().replace("+02:00", ""));

        // ES6 " ` " syntax ftw ^^
        $("#inb-c").after(`
                <div
                    id="${tempId}" 
                    class="dropdown-pane appointment-dropdown dropdown-stick-bottom top${
                      is_blocked ? " is-blocked" : ""
                    }${appointment_id != null ? " _is-rescheduled" : ""}"
                    data-dropdown
                    data-hover="true"
                    data-hover-pane="true"
                    data-position="bottom"
                    data-alignment="center"
                    data-close-on-click="true">
                    <aside class="inb-c-item__actions"> 
                        <a class="loadViaBackbone" href="appointments/${
                          that.options.active_calendar
                        }/event/${event.id}">
                            <button
                                class="button round"
                                type="button"
                                title="${that.t(
                                  "edit_${a}",
                                  { a: that.t("appointment") },
                                  "capital"
                                )}">
                                <i class="fi fi-pencil"></i>
                            </button>
                        </a>
                        <a
                            class="loadViaBackbone${!is_recurring ? " hide" : ""}"
                            href="appointments/${that.options.active_calendar}/event/${
          event.id
        }/block${params_for_recurring}${
          appointment_id !== null ? "&appointment_id=" + appointment_id : ""
        }">
                            <button
                                class="block-button button round"
                                type="button"
                                title="${that.t("toggle_event_blocked")}">
                                <i class="fi fi-power"></i>
                            </button>
                        </a>
                        <a
                            class="loadViaBackbone${!is_recurring ? " hide" : ""}"
                            href="appointments/${that.options.active_calendar}/event/${
          event.id
        }/reschedule${params_for_recurring}${
          appointment_id !== null ? "&appointment_id=" + appointment_id : ""
        }">
                            <button
                                class="reschedule-button button round${
                                  !is_recurring ? " hide" : ""
                                }"
                                title="${that.t("reschedule", null, "capital")}">
                                <i class="fi fi-clock"></i>
                            </button>
                        </a>
                    </aside>
                    <div class="appointment-dropdown__content">
                        <header class="clearfix">
                          <h5 class="inb-appointment-title float-left">
                              ${event.title}
                          </h5>
                        </header>
                        <span class="inb-list-title">
                          ${
                            event_date_title +
                            (false && is_recurring ? " (" + that.t("recurring") + ")" : "")
                          }
                        </span>
                        <ul class="inb-appointment-availabilities">
                            ${availabilities_per_contingent_rendered}
                        </ul>
                        ${renderedReservations}
                        <div class="hide appointment-dropdown__form${is_outbooked ? " hide" : ""}">
                          <div class="input-group hide">
                            <select>${renderedSelectOptions}</select>
                            <div class="input-group-button">
                              <button
                                  class="submit-add-reservation button"
                                  type="button">
                                  <i class="fi fi-check"></i>
                              </button>
                            </div>
                          </div>
                          <button class="toggle-input-group button expanded hollow">
                              + ${that.t("add_${a}", {
                                a: that.t("reservation"),
                              })}
                          </button>
                        </div>
                    </div>
                </div>`);

        // @todo NOT good:
        $(`#${tempId} .toggle-input-group`).click(function () {
          $(this).addClass("hide");
          $(this).parent().find(".input-group").removeClass("hide");
          return false;
        });

        $(`#${tempId} .submit-add-reservation`).click(function () {
          const pers_amount = $(this).closest(".appointment-dropdown__form").find("select").val();
          alert(pers_amount); // reuse params_for_recurring
          Backbone.history.navigate(
            "orders/add/&resourcetype=4&begin=" +
              start.format("YYYY-MM-DD HH:mm") +
              "&end=" +
              end.format("YYYY-MM-DD HH:mm") +
              "&event_id=" +
              event.id +
              "&amount=" +
              pers_amount,
            { trigger: true }
          );
        });

        const dropdown = new Foundation.Dropdown($("#" + tempId));
      },
    });

    $(".loadViaBackbone").click(function () {
      // Dunno the reason, but it seems as we need this...
      Backbone.history.navigate($(this).attr("href"), { trigger: true });
      return false;
    });

    const datepicker = new Datepicker({
      field: that.$el.find(".fc-center h2")[0],
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      maxDate,
      onSelect(date) {
        that.fc.fullCalendar("gotoDate", date);
        //eventsCollection.refetchEvents();
      },
      onOpen() {
        this.setMoment(that.fc.fullCalendar("getDate"));
        // @Deprecated: $('.pika-select-month').trigger('click');
      },
    });

    // Copy calendar header to outter frame
    this.getUI("calendarHeaderLeft").show().appendTo("#calendar .fc-left").find("input").val("");

    this.getUI("calendarHeaderRight").show().appendTo("#calendar .fc-right");
  },
});
